import React from "react";
import { useNavigate } from "react-router-dom";

const Voip = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/voip-business-solutions");
    window.scrollTo(0, 0);
  };

  return (
    <div className=" p-6 ">
      {/* <div className="text-center mb-6 ">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Our Services
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 mt-2 p-2">
          Ayanshtech delivers unparalleled expertise and state-of-the-art
          real-time communication solutions, tailored to empower businesses,
          enhance efficiency, and drive growth in today’s dynamic and
          competitive market landscape.
        </p>
      </div> */}

      <div className="flex flex-col lg:flex-row items-center lg:space-x-16">
        <div className="flex justify-center lg:w-1/2 mb-5 lg:mb-0">
          <img
            src="/assets/images/homeImages/voip.webp"
            alt="VoIP Development"
            className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
          />
        </div>

        <div className="lg:w-1/2 lg:text-left p-4">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-2">
           VoIP service provider for call centers
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed mb-3">
         A reliable <a  className="  relative   
  before:content-[''] before:absolute before:left-1/2 before:-bottom-1 
  before:h-[2px] before:w-0 before:bg-green-600 
  before:transition-all before:duration-300 
  hover:before:left-0 hover:before:w-full text-green-600 font-bold" href="https://ayanshtechnology.com/voip-business-solutions"> VoIP service provider for call centers </a> empowers your business with seamless, fast, and cost-efficient communication. With crystal-clear HD voice, intelligent call routing, IVR workflows, call recording, and real-time analytics, your agents can deliver an exceptional customer experience every time. Our cloud-based VoIP system allows remote teams to connect from anywhere and handle high-volume calls without interruption. Designed for scalability, security, and low operational costs, this solution strengthens your call center’s performance and ensures smooth customer interactions.
          </p>
          <button
            onClick={handleClick}
            className="bg-gradient-to-r from-blue-600 to-green-500 text-white px-6 py-3 rounded-full group hover:from-blue-900 hover:to-blue-600"
          >
            View More
          </button>
        </div>
      </div>
    </div>
  );
};

export default Voip;
